import { useMutation } from '@tanstack/react-query';
import { updateContactStatus as updateContactStatusService } from '../../api/ContactServiceAPI';

export const useUpdateContactStatus = () => {
    const {
        mutateAsync: updateContactStatus,
        isPending,
        ...rest
    } = useMutation({
        mutationFn: ({ id, status, note }: { id: string; status: string; note: string }) =>
            updateContactStatusService(id, status, note),
        retry: false,
    });

    return { updateContactStatus, isPending, ...rest };
};
